import React, { Component } from 'react';
import { Card, CardBody } from 'reactstrap';
import { isEmpty } from 'lodash';

import {  apiBaseUrl } from  '../../../configs/configs';
import LegalityView from './LegalityView';

class Legality extends Component {
  constructor(props) {
    super(props);

    this.state = {

      contentData: {},
      id: ''
        
    };
    
    this.getContent().then((res) => {
      this.setState({ contentData: res.result, id: res.result.id });
    }).catch(e => console.log(e));
    
  }

  async getContent(){

    const howtoplayApi = `${apiBaseUrl}/legality`;
    const response = await fetch(howtoplayApi);
    if(response.status === 200){
      const jsonResponse = await response.json();
      return jsonResponse;
    } else {
      return new Error();
    }
  }  

  render() {
    let legalityData = (this.state.contentData && this.state.contentData.legality) || {};
    try{
        legalityData = window.atob(legalityData);
    } catch(err) {
        console.log(err);
    }
    
    
    return (

      <div className="container">
        <Card>
          <CardBody>
            {!isEmpty(legalityData) && <LegalityView legalityData={legalityData}/>}
          </CardBody>
        </Card>
      </div>
      
        
    );
  }
}

export default Legality;
